import { render, staticRenderFns } from "./ReConfig.vue?vue&type=template&id=0150351f&scoped=true"
import script from "./ReConfig.vue?vue&type=script&lang=js"
export * from "./ReConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0150351f",
  null
  
)

export default component.exports